import {
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

const PreviewCohorts = ({ open, handleClose, parameterData }) => {
  console.log("parameterData", parameterData);
  return (
    <Dialog
      fullWidth
      open={open}
      onClose={() => handleClose()}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      maxWidth="md"
    >
      <DialogTitle id="alert-dialog-title">
        <Typography variant="h8">Cohort Details</Typography>
      </DialogTitle>
      <DialogContent>
        <IconButton
          aria-label="close"
          onClick={() => handleClose()}
          sx={(theme) => ({
            position: "absolute",
            right: 8,
            top: 8,
            color: theme.palette.grey[500],
          })}
        >
          <CloseIcon />
        </IconButton>
        <TableContainer
          component={Paper}
          variant="outlined"
          sx={{ maxHeight: 400 }}
        >
          <Table size="small" aria-label="a dense table" stickyHeader>
            <TableHead>
              <TableRow sx={{ background: "rgba(244, 247, 252, 0.75)" }}>
                {/* <TableCell sx={{ width: "10%" }}>
                  <Typography variant="h8">SL</Typography>
                </TableCell> */}
                <TableCell align="left" sx={{ width: "20%" }}>
                  <Typography variant="h9">Profile Name</Typography>
                </TableCell>
                <TableCell align="left" sx={{ width: "25%" }}>
                  <Typography variant="h9">Parameter Name</Typography>
                </TableCell>
                <TableCell align="left" sx={{ width: "15%" }}>
                  <Typography variant="h9">Result</Typography>
                </TableCell>
                <TableCell align="left" sx={{ width: "15%" }}>
                  <Typography variant="h9">Range</Typography>
                </TableCell>
                <TableCell align="left" sx={{ width: "15%" }}>
                  <Typography variant="h9">Tag</Typography>
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {parameterData?.length
                ? parameterData.map((each) =>
                    each.parameters.map((parameter, idx) => (
                      <TableRow
                        key={each.test_name}
                        sx={{
                          "&:last-child td, &:last-child th": { border: 0 },
                        }}
                      >
                        {/* <TableCell align="center">{idx + 1}</TableCell> */}
                        <TableCell align="left">
                          <Typography variant="body8">
                            {each.test_name}
                          </Typography>
                        </TableCell>
                        <TableCell align="left">
                          <Typography variant="body8">
                            {parameter.parameter_name}
                          </Typography>
                        </TableCell>
                        <TableCell align="left">
                          <Typography variant="body8">
                            {parameter.parameter_value}
                          </Typography>
                        </TableCell>
                        <TableCell align="left">
                          <Typography variant="body8">
                            {parameter.min_value} - {parameter.max_value}
                          </Typography>
                        </TableCell>
                        <TableCell align="left">
                          <Typography variant="body8">
                            {parameter?.tag?.comment
                              ? parameter.tag.comment
                              : ""}
                          </Typography>
                        </TableCell>
                      </TableRow>
                    ))
                  )
                : ""}
            </TableBody>
          </Table>
        </TableContainer>
      </DialogContent>
    </Dialog>
  );
};

export default PreviewCohorts;
